<template>
  <json-view-item
    :class="[{ 'root-item': true, dark: colorScheme === 'dark' }]"
    :data="parsed"
    :maxDepth="maxDepth"
    v-on:selected="itemSelected"
    :canSelect="hasSelectedListener"
    :collapse-open="open"
  />
</template>

<script>
import JsonViewItem from './JsonViewItem.vue';

const isDarkMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  .matches;

export default {
  name: 'json-view',
  props: {
    open: {
      default: false
    },
    data: {
      required: true
    },
    rootKey: {
      type: String,
      required: false,
      default: 'root'
    },
    maxDepth: {
      type: Number,
      required: false,
      default: 1
    },
    colorScheme: {
      type: String,
      required: false,
      default: 'light'
    }
  },
  components: {
    JsonViewItem
  },
  methods: {
    build: function(
      key,
      val,
      depth,
      path,
      includeKey
    ) {
      if (this.isObject(val)) {
        // Build Object
        let children = [];
        for (let [childKey, childValue] of Object.entries(val)) {
          children.push(
            this.build(
              childKey,
              childValue,
              depth + 1,
              includeKey ? `${path}${key}.` : `${path}`,
              true
            )
          );
        }
        return {
          key: key,
          type: 'object',
          depth: depth,
          path: path,
          length: children.length,
          children: children
        };
      } else if (this.isArray(val)) {
        // Build Array
        let children = [];
        for (let i = 0; i < val.length; i++) {
          children.push(
            this.build(
              i.toString(),
              val[i],
              depth + 1,
              includeKey ? `${path}${key}[${i}].` : `${path}`,
              false
            )
          );
        }
        return {
          key: key,
          type: 'array',
          depth: depth,
          path: path,
          length: children.length,
          children: children
        };
      } else {
        // Build Value
        return {
          key: key,
          type: 'value',
          path: includeKey ? path + key : path.slice(0, -1),
          depth: depth,
          value: val
        };
      }
    },
    isObject: function(val) {
      return typeof val === 'object' && val !== null && !this.isArray(val);
    },
    isArray: function(val) {
      return Array.isArray(val);
    },
    itemSelected: function(data) {
      this.$emit('selected', data);
    }
  },
  computed: {
    parsed: function() {
      if (typeof this.data === 'object') {
        return this.build(this.rootKey, { ...this.data }, 0, '', true);
      }
      return {
        key: this.rootKey,
        type: 'value',
        path: '',
        depth: 0,
        value: this.data
      };
    },
    hasSelectedListener() {
      return Boolean(this.$attrs && this.$attrs.selected);
    },
  }
};
</script>

<style lang="scss" scoped>
.root-item {
  --vjc-key-color: #131313;
  --vjc-valueKey-color: #073642;
  --vjc-string-color: #4e5052;
  --vjc-number-color: #2aa198;
  --vjc-boolean-color: #cb4b16;
  --vjc-null-color: #6c71c4;
  --vjc-arrow-size: 6px;
  --vjc-arrow-color: #444;
  --vjc-hover-color: rgba(0, 0, 0, 0.2);

  margin-left: 0;
  width: 100%;
  height: auto;
}
.root-item.dark {
  --vjc-key-color: #ccc;
  --vjc-valueKey-color: #fdf6e3;
  --vjc-hover-color: rgba(255, 255, 255, 0.782);
  --vjc-arrow-color: #fdf6e3;
}
</style>
